import { render, staticRenderFns } from "./NodeVehicleStatus.vue?vue&type=template&id=2b2a02ca&scoped=true&"
import script from "./NodeVehicleStatus.vue?vue&type=script&lang=js&"
export * from "./NodeVehicleStatus.vue?vue&type=script&lang=js&"
import style0 from "./NodeVehicleStatus.vue?vue&type=style&index=0&id=2b2a02ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2a02ca",
  null
  
)

export default component.exports